export const tableTitle = [
    'ID посилання',
    "Прізвище лікаря",
    'Біопсія',
    'Заключення',
    'Клінічна інформація',
    'Тип матеріала',
    'Дата операції',
    'Назва операції',
    'Кількість матеріалу',
    'Статус',
    'Відділ дослідження',
    'Скерування з іншої клініки',
    'Назва клініки',
    'Назва відділення',
];

export const filterDate = [
    {name: 'id', placeholder: 'Пошук за ID'},
    {name: 'activeDoc', placeholder: "Пошук за прізвищем лікаря"},
    {name: 'biopsy', placeholder: 'Пошук за біопсією'},
    {name: 'clinicalConclusion', placeholder: 'Пошук за клінічним заключенням'},
    {name: 'clinicalInfo', placeholder: 'Пошук за клінічною інформацією'},
    {name: 'markedMaterial', placeholder: 'Пошук за типом матеріала'},
    {name: 'operationDate', type: 'date', placeholder: 'Пошук за датою операції'},
    {name: 'operationName', placeholder: 'Пошук за назвою операції'},
    {name: 'quantityMaterial', placeholder: 'Пошук за кількістю матеріала'},
    {name: 'status', type: 'select', options: [{name:'Усі', value: ''}, {name:'Зареєстроване скерування', value: 'registered'},
            {name:'Сформована форма', value: 'scanAfterForm'},
            {name:'Готові до фарбування', value: 'scanBeforePaint'},
            {name:'Пофарбовані', value: 'scanAfterPaint'},
            {name:'Направлені до лікаря', value: 'toDoctor'}, {name:'Завершені', value: 'finished'}], placeholder: 'Пошук за статусом'},
    {name: 'research', type: 'select', options: [{name:'Усі', value: ''}, {name:'Гістологія', value: 'Гістологія'},
            {name:'ІГХ', value: 'ІГХ'},
            {name:'CISH', value: 'CISH'},
            {name:'Експрес', value: 'Експрес'},], placeholder: 'Пошук за відділом дослідження'},
    {name: 'outside', type: 'select', options: [{name:'Усі', value: ''}, {name:'Так', value: true}, {name:'Ні', value: false}], placeholder: 'Всі'},
    {name: 'hospital', placeholder: 'Пошук за клінікою'},
    {name: 'department', placeholder: 'Пошук за департаментом'},
]

export const searchOptions = [
    { "value": "id", "name": "за ID", "type": "number" },
    { "value": "activeDoc", "name": "за ім'ям лікаря", "type": "text" },
    { "value": "biopsy", "name": "за біопсією", "type": "text" },
    { "value": "clinicalConclusion", "name": "за клінічним заключенням", "type": "text" },
    { "value": "clinicalInfo", "name": "за клінічною інформацією", "type": "text" },
    { "value": "markedMaterial", "name": "за типом матеріала", "type": "text" },
    { "value": "operationDate", "name": "за датою операції", "type": "date" },
    { "value": "operationName", "name": "за назвою операції", "type": "text" },
    { "value": "quantityMaterial", "name": "за кількістю матеріала", "type": "text" },
    { "value": "status", "name": "за статусом", "type": "text" },
    { "value": "research", "name": "за відділом дослідження", "type": "text" },
    { "value": "createdAt", "name": "за датою створення", "type": "date" },
    { "value": "updatedAt", "name": "за датою оновлення", "type": "date" },
    { "value": "hospital", "name": "за номером клініки", "type": "number" },
    { "value": "department", "name": "за номером департамента", "type": "number" },
];